import { render, staticRenderFns } from "./DataProtectionPolicy.vue?vue&type=template&id=4ca682c5&scoped=true"
import script from "./DataProtectionPolicy.vue?vue&type=script&lang=js"
export * from "./DataProtectionPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca682c5",
  null
  
)

export default component.exports